import { defineComponent as _defineComponent } from 'vue'
import { withDefaults } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Loader',
  props: {
    value: { type: Boolean, default: false },
    withMask: { type: Boolean, default: false }
  },
  setup(__props: any) {



return { __sfc: true, }
}

})